export function Radio({ className, children, ...rest }: React.PropsWithChildren<React.InputHTMLAttributes<HTMLInputElement>>) {
    return (
        <div className={'size-[20px] flex justify-center items-center ' + className}>
            <input
                type='radio'
                className='size-[14px] appearance-none rounded-full bg-dark-night shadow-[0_0_0_3px_var(--color-dark-night)] checked:bg-turquoise-bright'
                {...rest}
            />
        </div>
    );
}
